import { nullish } from '../../../../shared/types/nullish.ts';
import { Batch } from '../../../types/sharedTypeImpl.ts';
import { formatDatetime } from '../../../utils/fieldFormats.ts';
import { MGraphMeasurement } from '../measurementsGraph.tsx';


export interface BatchStart {
    afterIndex: number;
    tooltip: string;
}

export function prepareBatchStarts(
    measurements: MGraphMeasurement[] | null,
    batches: Batch[] | nullish,
): BatchStart[] | null {
    if (!batches || batches.length === 0 || !measurements || measurements.length === 0) return null;

    const batchStarts: BatchStart[] = [];
    for (const batch of batches) {
        if (batch.start < measurements[0].date) continue;
        if (batch.start > measurements.at(-1)!.date) continue;

        const afterIndex = measurements.findLastIndex(it => it.date <= batch.start);
        const batchStart = {
            afterIndex,
            tooltip: `Batch start: ${formatDatetime(batch.start)}`,
        }
        batchStarts.push(batchStart);
    }
    return batchStarts;
}
